import { render, staticRenderFns } from "./FeeSchedules.vue?vue&type=template&id=b2b7bb08&scoped=true"
import script from "./FeeSchedules.vue?vue&type=script&lang=ts"
export * from "./FeeSchedules.vue?vue&type=script&lang=ts"
import style0 from "./FeeSchedules.vue?vue&type=style&index=0&id=b2b7bb08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b7bb08",
  null
  
)

export default component.exports